export default "__VITE_ASSET__CvdERoiQ__"